import { container } from 'tsyringe';
import { AuthRepository } from './Api/Auth';
import type { IAuthRepository } from './Api/Auth/interface';
import { MemberRepository } from './Api/Member';
import type { IMemberRepository } from './Api/Member/interface';

const keys = {
  AuthRepository: 'AuthRepository',
  MemberRepository: 'MemberRepository',
};

const c = container.createChildContainer();
c.register(keys.AuthRepository, {
  useValue: new AuthRepository(),
});
c.register(keys.MemberRepository, {
  useValue: new MemberRepository(),
});

export const repositoryGetter = {
  Auth: () => c.resolve<IAuthRepository>(keys.AuthRepository),
  Member: () => c.resolve<IMemberRepository>(keys.MemberRepository),
};
